import { BatchDeleteBillsModalActivity } from './batch-delete-bills';
import { DeleteBillActionModalActivity } from './delete-single-bill';

export const DeleteBillsModalActivity = (props: {
  billIds: string[];
  isOpen: boolean;
  onClose: VoidFunction;
  onSuccess?: VoidFunction;
}) => {
  const { billIds, ...rest } = props;
  if (billIds.length > 1) {
    return <BatchDeleteBillsModalActivity {...rest} billIds={billIds} />;
  }
  const [billId] = billIds;
  if (!billId) {
    return null;
  }

  return <DeleteBillActionModalActivity {...rest} billId={billId} />;
};
